<template>
  <div :class="$style.stage">
    <div :class="$style.heading_box">
      <h4>4つの会員ステージ</h4>
      <p
        >TENTIAL
        Clubには4つの会員ステージがあり、1年間（毎年4/1~翌3/31）※1に獲得したマイルに応じて翌年度のステージが決まります。途中で上位ステージのステージアップ条件を満たした場合は、翌日にステージが更新されます。また返品やキャンセルなどによってもステージが更新される場合があります。</p
      >
    </div>
    <ul :class="$style.membership_levels">
      <li v-for="stage of stageList" :key="stage.name">
        <div :class="$style.stage_indicator" :style="{ backgroundColor: stage.color }"></div>
        <div :class="$style.stage_info" :style="{ backgroundColor: stage.backgroundColor }">
          <div :class="$style.stage_name_box">
            <p :class="$style.stage_title">{{ stage.name }}</p>
            <p :class="$style.stage_kana">{{ stage.kana }}</p>
          </div>
          <div :class="$style.stage_mile_box">
            <p v-if="stage.mile" :class="$style.stage_description"
              >年間<span :class="$style.mile">{{ stage.mile.toLocaleString() }}</span
              >マイル獲得</p
            >
            <p v-else :class="$style.stage_description">{{ stage.description }}</p>
          </div>
        </div>
      </li>
    </ul>
    <p :class="$style.first_note">※初年度（2024年）のみ2024年5月15日～2025年3月31日</p>
    <h4>初年度開始時点（2024年5月15日）における会員ステージ</h4>
    <div :class="$style.second_note">
      <p
        >初年度開始時点（2024年5月15日）における会員ステージは、以下の合計を「初期ステージ算定用マイル」とし、上記の各会員ステージ到達条件のマイル数を基準に算定いたします。
      </p>
    </div>
    <div :class="$style.third_note">
      <p v-for="note of noteList" :key="note">{{ note }}</p>
    </div>
    <div :class="$style.forth_note">
      <p>お客様毎のステージは、2024年5月13日にご登録いただいているメールアドレス宛にお知らせいたします。</p>
      <p>また2024年5月15日開始時点では、全てのお客様一律で0マイルとなります。</p>
      <p
        >開始時点でプラチナ・ゴールドステージとなった方には特別マイルとして、プラチナ：1,500マイル、ゴールド：500マイルを5月下旬に付与いたします。</p
      >
    </div>
    <AtomsConsumerButton block variant="secondary" @click="() => router.push('/mypage')"
      >会員ステージを確認する</AtomsConsumerButton
    >
  </div>
</template>

<script setup lang="ts">
type Stage = {
  name: string
  kana: string
  backgroundColor: string
  color: string
  mile?: number
  description?: string
}
const stageList: Stage[] = [
  {
    name: "PLATINUM",
    kana: "プラチナ",
    backgroundColor: "#EBEBEB",
    color: "#9A9A9A",
    mile: 6000,
  },
  {
    name: "GOLD",
    kana: "ゴールド",
    backgroundColor: "#faf5ee",
    color: "#faf5ee",
    mile: 3000,
  },
  {
    name: "SILVER",
    kana: "シルバー",
    backgroundColor: "#F4F4F4",
    color: "#C8C8C8",
    mile: 1500,
  },
  {
    name: "REGULAR",
    kana: "レギュラー",
    backgroundColor: "#dde5f0",
    description: "会員登録",
    color: "#284B7D",
  },
]

const noteList = [
  "・2023年4月1日～2024年5月8日までにTENTIAL公式オンラインストアでご購入かつ出荷された累計購入金額（税込）×4%で計算",
  "・2023年11月16日～2024年5月8日までにTENTIAL Official Storeでデジタル会員証をご提示の上、ご購入された累計購入金額（税込）×4%で計算",
  "・2024年5月8日時点でのメールマガジンの受信設定（200マイル換算）",
  "・2024年5月8日時点でのLINE IDの連携（200マイル換算）",
]

const router = useRouter()
</script>

<style scoped module lang="scss">
.stage {
  padding: 0 1rem 44px 1rem;
  border-bottom: 1px solid $primary-20;
  margin-bottom: 44px;
  h4 {
    @include main-font;
    font-size: $font-size-20;
    color: $primary;
    margin-bottom: 18px;
  }

  .heading_box {
    margin-bottom: 18px;
  }
  .membership_levels {
    max-width: 500px;
    list-style: none;
    margin: 0 0 20px 0;

    li {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-left: 2px solid $secondary-20;
      padding-left: 20px;
      position: relative;

      .stage_indicator {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        position: absolute;
        left: -8px;
        top: 50%;
        transform: translateY(-50%);
      }
      .stage_info {
        padding: 1rem;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        gap: 0.5rem;

        .stage_title {
          font-weight: bold;
          font-size: $font-size-19;
        }

        .stage_kana {
          font-size: $font-size-13;
        }

        .stage_description {
          font-size: $font-size-13;
          .mile {
            font-size: $font-size-22;
            font-weight: bold;
            margin: 0 0.25rem 0 0.5rem;
          }
        }
      }
    }
  }
  .first_note {
    margin-bottom: 1rem;
  }
  > h4 {
    padding-bottom: 1rem;
    border-bottom: 1px solid $primary-20;
  }
  .second_note {
    margin-bottom: 1rem;
  }
  .third_note {
    margin-bottom: 1rem;
  }
  .forth_note {
    margin-bottom: 2rem;
  }
}
</style>
